// extracted by mini-css-extract-plugin
var _1 = "yjDKT";
var _2 = "Bw6y0";
var _3 = "Dioe0";
var _4 = "g63zl";
var _5 = "MeR21";
var _6 = "O4OP3";
var _7 = "Hq7UA";
var _8 = "tSPd9";
var _9 = "rzozy";
var _a = "yp52P";
var _b = "irXmU";
export { _1 as "base", _2 as "chart", _3 as "chartContainer", _4 as "chartTitle", _5 as "chartTypeSelector", _6 as "header", _7 as "row", _8 as "scoreChart", _9 as "scoreTitle", _a as "scores", _b as "theme-dark" }
